export enum ConnectorNames {
  Injected = 'Injected',
  WalletConnect = 'WalletConnect',
  BSC = 'BSC'
}
